import { render, staticRenderFns } from "./poll_replies.vue?vue&type=template&id=19d2fb0a&"
import script from "./poll_replies.vue?vue&type=script&lang=js&"
export * from "./poll_replies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports